import { useEffect } from "react";

export default function NfcRedirect() {
  useEffect(() => {
    window.location.replace("https://nfc-card-maker-1.emergentapps.tr/nfc/login");
  }, []);
  return null;
}
